import { nanoid } from '@reduxjs/toolkit';
import cn from 'classnames';

interface MeterProps {
  label?: string;
  value: number;
  minValue?: number;
  maxValue?: number;
  highLevel?: number;
  lowLevel?: number;
  className?: string;
  barClassName?: string;
}

export const Meter = (props: MeterProps) => {
  const {
    value,
    label,
    className = '',
    barClassName = '',
    lowLevel = 1,
    highLevel = 2,
    minValue = 0,
    maxValue = 3
  } = props;

  const percentage = (value - minValue) / (maxValue - minValue);
  const barWidth = `${Math.round(percentage * 100)}%`;
  const id = nanoid();
  return (
    <div
      aria-valuenow={value}
      aria-valuemax={maxValue}
      aria-valuemin={minValue}
      aria-labelledby={id}
      role="meter"
      className={cn('flex items-center space-x-1', className)}
    >
      {label && (
        <span
          id={id}
          className={cn('text-xs', {
            'text-content-positive': value > highLevel,
            'text-feedback-attention-strong':
              value > lowLevel && value <= highLevel,
            'text-feedback-error': value <= lowLevel
          })}
        >
          {label}
        </span>
      )}
      <div
        className={cn(
          'h-2 overflow-hidden rounded bg-surface-strong',
          barClassName
        )}
      >
        <div
          className={cn('h-2', {
            'bg-content-positive': value > highLevel,
            'bg-feedback-attention-strong':
              value > lowLevel && value <= highLevel,
            'bg-feedback-error': value <= lowLevel
          })}
          style={{ width: barWidth }}
        />
      </div>
    </div>
  );
};
